import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';
import { waterFillingMachines } from '../../mock/mockData';

const WaterFilling30BPM = () => {
  const productData = waterFillingMachines.find(p => p.id === 'wfm-30');
  return <ProductPageTemplate productData={productData} />;
};

export default WaterFilling30BPM;